export class EventMarketOutcomeNamesDTO {
    eventMarketOutcomeName;
    teamName;
    playerName;
    constructor(eventMarketOutcomeName, teamName, playerName) {
        this.eventMarketOutcomeName = eventMarketOutcomeName;
        this.teamName = teamName;
        this.playerName = playerName;
    }
}
